import React from 'react';
import { withTheme } from 'styled-components';
import { Box } from '@rsos/components/capstone/base';
import { DARK_THEME, DARKER_THEME } from '@rsos/theme/constants';
import { RapidSOSLogoCompact, FullLogo } from '../../common/logo/RapidSOSLogo';
import { PremiumText, TextContainer } from './PremiumLogo.styles';

const PremiumLogo = ({ theme, compact, showUniteLogo = false }) => {
  const { name: themeName = '' } = theme.colors;

  return compact ? (
    <RapidSOSLogoCompact />
  ) : (
    <Box horizontal flow={7} align="center">
      <FullLogo
        color={
          themeName == DARK_THEME || themeName === DARKER_THEME
            ? 'background'
            : 'primaryText'
        }
      />
      {showUniteLogo && (
        <TextContainer>
          <PremiumText
            color={
              themeName === DARK_THEME || themeName === DARKER_THEME
                ? 'background'
                : 'primaryText'
            }
          />
        </TextContainer>
      )}
    </Box>
  );
};
export default withTheme(PremiumLogo);
